import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=66f565bd&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f565bd')) {
      api.createRecord('66f565bd', component.options)
    } else {
      api.reload('66f565bd', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=66f565bd&", function () {
      api.rerender('66f565bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/comp/openstreetmap.vue"
export default component.exports